module.exports = __webpack_public_path__ + "static/media/rapidsnow-icon.2ee4fcc0.svg";